var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "bg-white" },
      [
        _c(
          "div",
          { staticClass: "p-5" },
          [
            _vm.listQuery.position_id
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      to: "/adver/edit?pid=" + _vm.listQuery.position_id,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-plus",
                        },
                      },
                      [_vm._v("添加")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "ptd-5",
            attrs: {
              data: _vm.list,
              "element-loading-text": "Loading",
              stripe: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "ID", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("div", [_vm._v(_vm._s(scope.row.id))])]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "图片", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-image", {
                        staticStyle: { width: "100px", height: "100px" },
                        attrs: {
                          src: scope.row.img_url,
                          "preview-src-list": [scope.row.img_url],
                          fit: "cover",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "名称", width: "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.ad_name) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "时间", width: "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.parseTime(
                                scope.row.start_date,
                                "{y}-{m}-{d} {h}:{i}"
                              )
                            )
                          ),
                          _c("el-link", { attrs: { type: "primary" } }, [
                            _vm._v("起"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.parseTime(
                                scope.row.end_date,
                                "{y}-{m}-{d} {h}:{i}"
                              )
                            )
                          ),
                          _c("el-link", { attrs: { type: "danger" } }, [
                            _vm._v("止"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "定向地址" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        { attrs: { type: "primary", href: scope.row.ad_link } },
                        [_vm._v(_vm._s(scope.row.ad_link))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "投放类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            scope.row.is_all == 1 ? "全部投放" : "指定设备投放"
                          ) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "状态", width: "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(_vm.statusObj[scope.row.review_status])),
                      ]),
                      _vm._v(" "),
                      scope.row.review_status == 3
                        ? _c("div", [
                            _vm._v(
                              "失败原因：" + _vm._s(scope.row.refuse_reason)
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.review_status == 2
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setShow(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  scope.row.is_show == 1 ? "已显示" : "未显示"
                                )
                              ),
                            ]
                          )
                        : scope.row.review_status == 0 ||
                          scope.row.review_status == 3
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setReview(scope.row)
                                },
                              },
                            },
                            [_vm._v("提交审核")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.is_all == 0
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({
                                    path:
                                      "/equipment/index?ad_id=" +
                                      scope.row.id +
                                      "&all=1",
                                  })
                                },
                              },
                            },
                            [_vm._v("绑定设备")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p"),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                path: "/adver/edit/?id=" + scope.row.id,
                              })
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-center" },
          [
            _c("pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listQuery.page_num > 0,
                  expression: "listQuery.page_num > 0",
                },
              ],
              attrs: {
                page: _vm.listQuery.start,
                "page-count": _vm.listQuery.page_num,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "start", $event)
                },
                pagination: _vm.getList,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }